import { PriceBreakUpItem } from '@/src/types/fareFamilyInfo'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { InfoOutline } from '@mui/icons-material'
import { Box, ClickAwayListener, Tooltip, Typography } from '@mui/material'
import TimelinePriceBreakupWrapper from '../timelinePriceBreakup'

interface TimelineProps {
    timeSegments: string[]
    priceSegments: { priceValue: string; priceBreakUp: PriceBreakUpItem[] }[]
    segmentCount: number
    timeLineColorMap: string[]
    title: string
    blockTitle: string
    tooltipOpen: boolean
    setTooltipOpen: (open: boolean) => void
}

const Timeline: React.FC<TimelineProps> = ({
    timeSegments,
    priceSegments,
    segmentCount,
    title,
    timeLineColorMap,
    blockTitle,
    tooltipOpen,
    setTooltipOpen
}) => {
    return (
        <Box sx={{ px: 1.5, pb: 2 }}>
            {/* Date headers with smaller font */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1,
                    fontWeight: 500
                }}
            >
                <Typography sx={{ flex: 1, fontSize: 10, color: 'textColors.subheading' }}>{blockTitle}</Typography>
                {timeSegments.slice(0, segmentCount).map((time, index) => (
                    <Typography
                        key={index}
                        sx={{
                            flex: 1,
                            textAlign: index === segmentCount - 1 ? 'right' : 'center',
                            fontSize: 10,
                            color: 'textColors.subheading'
                        }}
                    >
                        {time}
                    </Typography>
                ))}
            </Box>

            {/* Timeline blocks with prices inside */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.2 }}>
                {Array.from({ length: segmentCount }).map((_, index) => {
                    const { priceValue, priceBreakUp } = priceSegments[index] || { priceValue: '', priceBreakUp: [] }

                    return (
                        <Box
                            key={index}
                            sx={{
                                flex: 1,
                                height: 24,
                                borderRadius: 0.5,
                                bgcolor: timeLineColorMap[index],
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.5,
                                px: 1,
                                position: 'relative'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: 'neutral.white',
                                    textAlign: 'center'
                                }}
                            >
                                {priceValue}
                            </Typography>
                            {!isEmpty(priceBreakUp) && (
                                <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
                                    <Tooltip
                                        title={<TimelinePriceBreakupWrapper priceBreakup={priceBreakUp} />}
                                        open={tooltipOpen}
                                        disableHoverListener={true}
                                        disableFocusListener={true}
                                        disableTouchListener={true}
                                        onClose={() => setTooltipOpen(false)}
                                    >
                                        <InfoOutline
                                            sx={{
                                                fontSize: '14px',
                                                color: 'neutral.white',
                                                cursor: 'pointer',
                                                ml: 0.5
                                            }}
                                            onClick={() => setTooltipOpen(true)}
                                        />
                                    </Tooltip>
                                </ClickAwayListener>
                            )}
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default Timeline
